/* MedSchoolBro — PDP add-on bundle selector */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (!format) return '$' + amount;
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function Addon(root) {
    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat || '';
    this.atcText = root.dataset.atcText || 'Add To Cart';
    this.selectText = root.dataset.selectText || 'Select Options';

    this.formatStep = root.querySelector('[data-step="format"]');
    this.addonStep = root.querySelector('[data-step="addon"]');
    this.formatInputs = root.querySelectorAll('[data-format]');
    this.addonInputs = root.querySelectorAll('[data-addon]');
    this.totalEl = root.querySelector('[data-total]');
    this.noteEl = root.querySelector('[data-note]');
    this.atc = root.querySelector('[data-atc]');
    this.formatSub = root.querySelector('[data-format-sub]');
    this.addonSub = root.querySelector('[data-addon-sub]');
    this.pendingText = this.addonSub ? this.addonSub.textContent : '';

    this.formatPrice = 0;
    this.formatCompare = 0;
    this.formatId = null;
    this.addonPrice = null;
    this.addonIds = [];
    this.addonCompare = 0;
    this.addonLabel = '';

    this.applyCurrency();
    this.bind();
    this.readFormat();
    this.render();
  }

  Addon.prototype.bind = function () {
    var self = this;

    this.root.querySelectorAll('[data-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('[data-step]');
        var open = step.getAttribute('aria-expanded') !== 'true';
        self.setStep(step, open);
        if (open && step === self.addonStep) self.setStep(self.formatStep, false);
      });
    });

    /* click fires even when the radio is already checked; change does not */
    this.formatInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        self.readFormat();
        self.render();
        self.setStep(self.formatStep, false);
        if (self.addonPrice === null) self.setStep(self.addonStep, true);
      });
      input.addEventListener('change', function () {
        self.readFormat();
        self.render();
      });
    });

    this.addonInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        self.addonPrice = parseInt(input.dataset.price, 10);
        self.addonIds = input.value
          ? input.value.split(',').map(function (v) { return Number(v.trim()); }).filter(Boolean)
          : [];
        self.addonLabel = input.dataset.label || '';
        self.addonDisplay = input.dataset.display ? parseInt(input.dataset.display, 10) : null;
        self.addonCompare = parseInt(input.dataset.compare, 10) || 0;
        self.render();
        self.setStep(self.addonStep, false);
        self.showGallery(input.dataset.gallery);
        self.centerBar();
      });
    });

    if (this.atc) {
      this.atc.addEventListener('click', function () {
        if (self.addonPrice === null) {
          self.setStep(self.formatStep, false);
          self.setStep(self.addonStep, true);
          return;
        }
        self.addToCart();
      });
    }

    /* bfcache restore: never leave the button stuck on "Adding…" */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && self.atc) {
        self.atc.classList.remove('is-busy');
        self.render();
      }
    });
  };

  /* Move the product gallery to the image for the chosen bundle.
     n counts from the end: -1 = last image. */
  Addon.prototype.showGallery = function (n) {
    n = parseInt(n, 10);
    if (!n) return;
    var viewer = document.querySelector('media-gallery .product__media-gallery-viewer');
    var sw = viewer && viewer.swiper;
    if (!viewer) return;
    var real = viewer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    if (!real.length) real = viewer.querySelectorAll('.product__media-list > *');
    var i = real.length + n;
    if (i < 0 || i >= real.length) return;
    if (sw) {
      if (sw.params && sw.params.loop && sw.slideToLoop) sw.slideToLoop(i);
      else sw.slideTo(i);
    } else {
      /* desktop grid layout (no slider): click its thumbnail if there is one */
      var thumb = document.querySelectorAll('media-gallery .product__thumbs-item')[i];
      if (thumb) thumb.click();
    }
  };

  /* Other currencies: Shopify converts each bundle's USD discount at its
     exchange rate (capped by the % of the local price), not by the theme's
     price ratio. Recompute add-on prices the same way so PDP = checkout. */
  Addon.prototype.applyCurrency = function () {
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur ? parseFloat(cur.rate) : 1;
    if (!rate || Math.abs(rate - 1) < 0.0001) return;
    var fmt = this.moneyFormat;
    var trim = function (c) { return formatMoney(c, fmt).replace(/[.,]00(?!\d)/, ''); };
    this.addonInputs.forEach(function (input) {
      var list = parseInt(input.dataset.compare, 10) || 0;
      var listUsd = parseInt(input.dataset.listUsd, 10) || 0;
      var conv = function (offUsd) {
        var byRate = Math.round(offUsd * rate);
        var byPct = listUsd ? Math.round(offUsd * list / listUsd) : byRate;
        return Math.min(byRate, byPct, list);
      };
      var opt = input.closest('.msb-opt');
      var off = parseInt(input.dataset.offUsd, 10);
      if (off) {
        var offLocal = conv(off);
        var pay = list - offLocal;
        input.dataset.price = pay;
        if (input.dataset.priceMulti) input.dataset.priceMulti = pay;
        var box = opt && (opt.querySelector('[data-prices-multi]') || opt.querySelector('.msb-opt-prices'));
        if (box) {
          var now = box.querySelector('.msb-now'); if (now) now.textContent = formatMoney(pay, fmt);
          var sv = box.querySelector('.msb-save'); if (sv) sv.textContent = 'Save ' + trim(offLocal);
        }
      }
      var offS = parseInt(input.dataset.offSingleUsd, 10);
      if (offS && input.dataset.priceSingle) {
        var offSL = conv(offS);
        var payS = list - offSL;
        input.dataset.priceSingle = payS;
        var boxS = opt && opt.querySelector('[data-prices-single]');
        if (boxS) {
          var nowS = boxS.querySelector('.msb-now'); if (nowS) nowS.textContent = formatMoney(payS, fmt);
          var svS = boxS.querySelector('.msb-save'); if (svS) svS.textContent = 'Save ' + trim(offSL);
        }
      }
    });
  };

  Addon.prototype.setStep = function (step, open) {
    if (!step) return;
    step.setAttribute('aria-expanded', open ? 'true' : 'false');
    var btn = step.querySelector('[data-toggle]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.marks();
  };

  Addon.prototype.centerBar = function () {
    if (window.innerWidth >= 768) return;
    var bar = this.root.querySelector('[data-bar]');
    if (!bar) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var rect = bar.getBoundingClientRect();
        var target = window.scrollY + rect.top + rect.height / 2 - window.innerHeight / 2;
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (target < 0) target = 0;
        if (target > max) target = max;
        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        window.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  };

  Addon.prototype.marks = function () {
    if (this.formatStep) {
      var fDone = this.formatStep.getAttribute('aria-expanded') === 'false' && this.formatId;
      this.formatStep.classList.toggle('is-complete', !!fDone);
    }
    if (this.addonStep) {
      var aDone = this.addonStep.getAttribute('aria-expanded') === 'false' && this.addonPrice !== null;
      this.addonStep.classList.toggle('is-complete', !!aDone);
    }
  };

  Addon.prototype.readFormat = function () {
    var checked = this.root.querySelector('[data-format]:checked');
    if (!checked) return;
    this.formatPrice = parseInt(checked.dataset.price, 10);
    this.formatCompare = parseInt(checked.dataset.compare, 10) || this.formatPrice;
    this.formatId = checked.value;
    this.applyVariantRules(checked);
    this.applyPct();
    if (this.formatSub) {
      this.formatSub.textContent =
        checked.dataset.label + ' \u00B7 ' + formatMoney(this.formatPrice, this.moneyFormat);
    }
  };

  /* Single flashcard set selected (variant title without "+"): hide the
     multi-set-only offers and switch guide offers to their single-set price. */
  /* Flashcard set size from the selected variant title:
     no "+" (and no "All") = single, one "+" = two, otherwise all.
     Hides multi-only offers for singles and swaps in the right price. */
  Addon.prototype.applyVariantRules = function (checked) {
    if (!this.root.hasAttribute('data-single-aware')) return;
    var t = (checked.dataset.label || '').toLowerCase();
    var plus = (t.match(/\+/g) || []).length;
    var tier = t.indexOf('all') > -1 || plus >= 2 ? 'multi' : plus === 1 ? 'two' : 'single';
    var self = this;
    this.addonInputs.forEach(function (input) {
      var opt = input.closest('.msb-opt');
      if (input.hasAttribute('data-only-multi')) {
        var hide = tier === 'single';
        if (opt) opt.style.display = hide ? 'none' : '';
        if (hide && input.checked) {
          input.checked = false;
          self.addonPrice = null;
          self.addonIds = [];
          self.addonCompare = 0;
          self.addonLabel = '';
        }
      }
      if (input.dataset.priceMulti) {
        var price = input.dataset.priceMulti;
        var show = 'multi';
        if (tier === 'single' && input.dataset.priceSingle) { price = input.dataset.priceSingle; show = 'single'; }
        if (tier === 'two' && input.dataset.priceTwo) { price = input.dataset.priceTwo; show = 'two'; }
        input.dataset.price = price;
        ['multi', 'two', 'single'].forEach(function (k) {
          var el = opt && opt.querySelector('[data-prices-' + k + ']');
          if (el) el.style.display = k === show ? '' : 'none';
        });
        if (input.checked) self.addonPrice = parseInt(price, 10);
      }
    });
  };

  /* % offers: the add-on is priced so (product + add-on) = (100 - pct)% */
  Addon.prototype.applyPct = function () {
    var self = this;
    this.addonInputs.forEach(function (input) {
      var pct = parseInt(input.dataset.pct, 10);
      if (!pct) return;
      var list = parseInt(input.dataset.compare, 10) || 0;
      var orderPay = Math.round((self.formatPrice + list) * (100 - pct) / 100);
      var pay = orderPay - self.formatPrice;
      input.dataset.price = pay;
      if (input.checked) self.addonPrice = pay;
    });
  };

  Addon.prototype.render = function () {
    var chosen = this.addonPrice !== null;
    var total = this.formatPrice + (this.addonPrice || 0);
    /* With an add-on, strike the format's selling price + the add-on's list
       price (not the format's compare-at), so savings = the bundle discount. */
    var withAddon = chosen && this.addonIds.length > 0;
    var baseCompare = withAddon ? this.formatPrice : this.formatCompare;
    var compareTotal = baseCompare + (this.addonCompare || 0);

    if (this.totalEl) {
      var html = '<span class="msb-total-now">' + formatMoney(total, this.moneyFormat) + '</span>';
      if (compareTotal > total) {
        html += '<s class="msb-total-was">' + formatMoney(compareTotal, this.moneyFormat) + '</s>';
      }
      this.totalEl.innerHTML = html;
    }

    var sq = document.querySelector('square-placement[data-amount]');
    if (sq) sq.setAttribute('data-amount', (total / 100).toFixed(2));

    if (!chosen) {
      if (this.addonStep) this.addonStep.classList.add('is-pending');
      if (this.addonSub) this.addonSub.textContent = this.pendingText;
      if (this.atc) this.atc.textContent = this.selectText;
      this.marks();
      return;
    }

    if (this.addonStep) this.addonStep.classList.remove('is-pending');
    if (this.addonSub) {
      this.addonSub.textContent = this.addonIds.length
        ? this.addonLabel + ' \u00B7 ' + formatMoney(this.addonDisplay != null ? this.addonDisplay : this.addonPrice, this.moneyFormat)
        : this.addonLabel;
    }
    if (this.noteEl) {
      var saved = Math.max(0, compareTotal - total);
      this.noteEl.innerHTML = saved > 0
        ? 'You save <b>' + formatMoney(saved, this.moneyFormat) + '</b>'
        : '';
    }
    if (this.atc) this.atc.textContent = this.atcText;
    this.marks();
  };

  Addon.prototype.addToCart = function () {
    var self = this;
    if (!this.formatId) return;
    if (this.atc && this.atc.classList.contains('is-busy')) return;

    var items = [{ id: Number(this.formatId), quantity: 1 }];
    this.addonIds.forEach(function (id) { items.push({ id: id, quantity: 1 }); });

    var label = this.atc.textContent;
    this.atc.classList.add('is-busy');
    this.atc.textContent = 'Adding\u2026';

    fetch((((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function (payload) {
        self.atc.classList.remove('is-busy');
        self.atc.textContent = 'Added';
        if (typeof window.msbAfterAdd === 'function') window.msbAfterAdd(payload);
        else window.location.href = (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart');
        setTimeout(function () { self.atc.textContent = label; }, 1500);
      })
      .catch(function (err) {
        self.atc.classList.remove('is-busy');
        self.atc.textContent = label;
        if (self.noteEl) {
          self.noteEl.textContent =
            (err && err.description) || 'Could not add to cart. Please try again.';
        }
      });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-msb-addon]').forEach(function (el) {
      if (el.dataset.msbReady) return;
      el.dataset.msbReady = '1';
      new Addon(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
